import React from 'react';
import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

const StyledTextarea = styled.textarea`
  width: 100%;
  font-size: 14px;
  line-height: normal;
  padding: 10px;
  border: ${(props: { disabled: boolean }) =>
    props.disabled ? '1px dashed #d1d1d1' : '1px solid #d1d1d1'};
  border-radius: 4px;
  background: #ffffff;
  box-sizing: border-box;

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
    opacity: 1;
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
  }
  &:-moz-placeholder {
    /* Firefox 18- */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
    opacity: 1;
  }
`;

const StyledTextareaAutosize = styled(TextareaAutosize)`
  resize: none;
  min-height: 55px;
  width: 67%;
  background: #ffffff;
  border: ${(props: { disabled: boolean }) =>
    props.disabled ? '1px dashed #d1d1d1' : '1px solid #d1d1d1'};
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 5px;
  font-size: 14px;
  outline: 0;
  -webkit-appearance: none;
  float: left;
  caret-color: #00a0f0;
  padding: 10px;

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
  }

  &:-ms-input-placeholder {
    /* IE 10+ */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
  }

  &:-moz-placeholder {
    /* Firefox 18- */
    color: ${(props: { disabled: boolean }) =>
      props.disabled ? '#9c9c9c' : '#333'};
  }
`;

interface Props {
  disabled: boolean;
  isWide: boolean;
  onChange: Function;
  placeholder: string;
  value: string;
}

export const ChatInput = (props: Props) => {
  const { disabled, isWide, onChange, placeholder, value } = props;

  return isWide ? (
    <StyledTextarea
      rows={7}
      disabled={disabled}
      onChange={(event) => {
        onChange(event);
      }}
      placeholder={placeholder}
      value={value}
    />
  ) : (
    <StyledTextareaAutosize
      minRows={2}
      maxRows={7}
      disabled={disabled}
      onChange={(event) => {
        onChange(event);
      }}
      placeholder={placeholder}
      value={value}
    />
  );
};
